<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <path
      d="M73.0845 13.3843L74.1133 9.50287C74.1434 9.38933 74.1956 9.28282 74.2668 9.18944C74.3381 9.09606 74.4271 9.01763 74.5286 8.95864C74.6302 8.89964 74.7424 8.86123 74.8588 8.8456C74.9752 8.82997 75.0936 8.83743 75.2071 8.86754L98.1281 14.9445C98.2416 14.9746 98.3481 15.0268 98.4415 15.098C98.5349 15.1693 98.6133 15.2583 98.6723 15.3598C98.7313 15.4614 98.7697 15.5736 98.7854 15.69C98.801 15.8064 98.7935 15.9248 98.7634 16.0383L90.5076 47.1742C90.4693 47.3169 90.3965 47.448 90.2955 47.5558C90.1945 47.6636 90.0685 47.7449 89.9286 47.7925C89.7887 47.8401 89.6393 47.8524 89.4935 47.8285C89.3477 47.8046 89.21 47.7451 89.0927 47.6554"
      fill="white"
    />
    <path
      d="M73.0845 13.3843L74.1133 9.50287C74.1434 9.38933 74.1956 9.28282 74.2668 9.18944C74.3381 9.09606 74.4271 9.01763 74.5286 8.95864C74.6302 8.89964 74.7424 8.86123 74.8588 8.8456C74.9752 8.82997 75.0936 8.83743 75.2071 8.86754L98.1281 14.9445C98.2416 14.9746 98.3481 15.0268 98.4415 15.098C98.5349 15.1693 98.6133 15.2583 98.6723 15.3598C98.7313 15.4614 98.7697 15.5736 98.7854 15.69C98.801 15.8064 98.7935 15.9248 98.7634 16.0383L90.5076 47.1742C90.4693 47.3169 90.3965 47.448 90.2955 47.5558C90.1945 47.6636 90.0685 47.7449 89.9286 47.7925C89.7887 47.8401 89.6393 47.8524 89.4935 47.8285C89.3477 47.8046 89.21 47.7451 89.0927 47.6554"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M62.5654 48.3018L54.2456 20.6952C54.1771 20.4681 54.2016 20.2231 54.3138 20.0141C54.4259 19.8051 54.6164 19.6492 54.8435 19.5807L77.5478 12.7384C77.7742 12.6707 78.0182 12.6954 78.2265 12.8071C78.4348 12.9187 78.5904 13.1083 78.6593 13.3343L80.5801 19.7043"
      fill="white"
    />
    <path
      d="M62.5654 48.3018L54.2456 20.6952C54.1771 20.4681 54.2016 20.2231 54.3138 20.0141C54.4259 19.8051 54.6164 19.6492 54.8435 19.5807L77.5478 12.7384C77.7742 12.6707 78.0182 12.6954 78.2265 12.8071C78.4348 12.9187 78.5904 13.1083 78.6593 13.3343L80.5801 19.7043"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M62.2964 52.6393L64.3981 18.7036L89.85 20.2799L87.7483 54.2156L62.2964 52.6393Z"
      fill="#D9EDE2"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M86.6805 72.4409H12.8055C12.3274 72.4409 11.8689 72.6308 11.5309 72.9689C11.1928 73.3069 11.0029 73.7654 11.0029 74.2435V77.8471H88.483V74.2464C88.4834 74.0095 88.4371 73.7747 88.3467 73.5557C88.2562 73.3367 88.1235 73.1376 87.9561 72.9699C87.7887 72.8022 87.5899 72.6692 87.371 72.5784C87.1521 72.4876 86.9174 72.4409 86.6805 72.4409Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M88.4831 77.8501H11C11.5888 78.9745 12.4836 79.9095 13.5811 80.5472C14.6786 81.1848 15.9341 81.4991 17.2025 81.4537H82.3115C83.5704 81.4982 84.8162 81.1862 85.9054 80.5536C86.9947 79.9211 87.8831 78.9936 88.4683 77.8782L88.4831 77.8501Z"
      fill="#211F58"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M83.0767 34.6036C83.0767 33.6479 82.6971 32.7313 82.0212 32.0555C81.3454 31.3797 80.4288 31 79.4731 31H20.0096C19.0539 31 18.1373 31.3797 17.4615 32.0555C16.7857 32.7313 16.406 33.6479 16.406 34.6036V72.4409H83.0767V34.6036Z"
      fill="#E4F1FF"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M25.4163 40.0098H74.0674V65.2366H25.4163V40.0098Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M34.4258 40.0098V65.2366"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.0198 45.416H30.8223"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.0198 50.2209H30.8223"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.0198 55.0256H30.8223"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.0198 59.8303H30.8223"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M38.0293 45.416H43.4355"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M41.6328 50.2209H56.0488"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M38.0293 55.0256H47.0391"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M41.6328 59.8303H53.345"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
